sharpen-story-page {
  display: block;
  background-color: white;
  box-shadow: rgba(0,0,0,0.5) 0 1em 3em;
  overflow-y: hidden;

  .content {
    padding: var(--spacing-lg);
    color: var(--color-pine);
  }

  &[content-mode="sentence"] .content { font-size: 28pt; }
  &[content-mode="paragraph"] .content { font-size: 14pt; line-height: 1.5; }

  .story-footer {
    height: auto;
    aspect-ratio: 10 / 6.5;
    margin-top: 0;
    display: flex;
    flex-wrap: wrap;
    align-content: end;
    padding-bottom: 1em;
    justify-content: center;

    background-size: 100%;
    background-repeat: no-repeat;
    background-position: bottom;

    img {
      width: auto;
      height: 50%;
      margin-top: 0;
      aspect-ratio: 1 / 1;
    }
  }

  .text { opacity: 0; }
  p + p { margin-top: 1em; }

}
